import { Modal, Button, Form } from 'react-bootstrap';
import { useState } from 'react';
import axios from 'axios';
import config from '../../config';
import { toast } from 'react-toastify';

function AddGroupModal({ show, onHide, onGroupAdded }) {
    const [form, setForm] = useState({
        groupName: '',
        groupCode: '',
        description: ''
    });

    const handleChange = e => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async e => {
        e.preventDefault();
        try {
            await axios.post(`${config.API_BASE_URL}/groups/new`, form);
            toast.success("Group added successfully");
            onGroupAdded();
            setForm({ groupName: '', groupCode: '', description: '' });
        } catch (err) {
            toast.error(err.response?.data?.message || "Error adding group");
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Group</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Group Name</Form.Label>
                        <Form.Control name="groupName" value={form.groupName} onChange={handleChange} required />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Group Code</Form.Label>
                        <Form.Control name="groupCode" value={form.groupCode} onChange={handleChange} required />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control as="textarea" name="description" value={form.description} onChange={handleChange} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>Cancel</Button>
                    <Button type="submit" variant="primary">Save</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default AddGroupModal;